export default "__VITE_ASSET__CBN_xnZN__"